import React from 'react';
import {useHistory} from "react-router-dom";
import * as constants from "../const/constants";

export default function CourseCertificateCard({course, certificateId}) {

    const history = useHistory();

    const {courseId, name, courseNameOnCertificate, imageUrl} = course;

    function handleCertificateViewOnAction() {
        history.push({
            pathname: `${constants.BASE_ROUTE}${constants.HOME_PREVIEW_CERTIFICATE_ROUTE}${certificateId}`,
            state: {id: certificateId}
        })
    }

    return (
        <div style={{
            boxShadow: "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
            borderRadius: 10,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            justifyContent: 'center',
            padding: 15,
            color: '#000000',
            gap: 10
        }}>
            <div style={{width: '100%'}}>
                <img alt={""} style={{width: '100%', aspectRatio: "4/2", borderRadius: 10}}
                     src={imageUrl ? imageUrl : ""}/>
            </div>
            <p style={{
                padding: 0,
                margin: 0,
                fontSize: '1.2rem',
                textAlign: 'start',
                width: '100%',
                fontWeight: 'bold'
            }}>{name ? name : ""}</p>
            <button
                onClick={handleCertificateViewOnAction}
                style={{
                    background: 'maroon',
                    color: 'white',
                    borderRadius: 5,
                    padding: 10,
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                    letterSpacing: 1
                }}>
                VIEW CERTIFICATE
            </button>
        </div>
    );
}